import clsx from 'clsx';
import React from 'react';
import { DateSource } from 'react-intl';

import { RelativeTime } from '../../../../../../components/RelativeTime';
import getComponentClasses from '../../../../../../utils/app/getComponentClasses';

export type IconType =
    | 'comment'
    | 'design'
    | 'folder'
    | 'invoice'
    | 'like'
    | 'promote'
    | 'sent'
    | 'trophy';

export type Notification = {
    thumbnailUrl?: string | null;
    icon: IconType | null;
    isRead: boolean | null;
    destinationUrl: string | null;
    messageHtml: string | null;
    lastActivityAt: DateSource | null;
};

export interface Props {
    notification: Notification;
}

export default class OnsiteNotificationsListItem extends React.Component<Props> {
    thumbnail() {
        if (!this.props.notification.thumbnailUrl) {
            return null;
        }

        return (
            <img
                alt=""
                className="onsite-notifications__list-item__thumbnail"
                src={this.props.notification.thumbnailUrl}
            />
        );
    }

    render() {
        const {
            destinationUrl,
            icon,
            isRead,
            lastActivityAt,
            messageHtml,
        } = this.props.notification;

        const classes = clsx({
            'onsite-notifications__list-item': true,
            'onsite-notifications__list-item--read': isRead,
        });

        const href = destinationUrl ? destinationUrl : '#';
        const __html = messageHtml ? messageHtml : '';
        const iconClasses = icon
            ? getComponentClasses('onsite-notifications__icon', [icon])
            : 'onsite-notifications__icon';
        const date = lastActivityAt ? lastActivityAt : Date.now();

        return (
            <a className={classes} href={href}>
                <div className="onsite-notifications__list-item__content">
                    <div
                        className="onsite-notifications__list-item__message"
                        dangerouslySetInnerHTML={{ __html }}
                    />
                    <div className="onsite-notifications__list-item__metadata">
                        <span className={iconClasses} />
                        <span className="onsite-notifications__list-item__updated-at">
                            <RelativeTime date={date} />
                        </span>
                    </div>
                </div>
                {this.thumbnail()}
            </a>
        );
    }
}
